import { imageURL } from '../endpoints';

function ImageService( { access_token } ) {
    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };

    const saveImage = async ( image ) => {
        const res = await fetchWithAuth( imageURL, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify( {
                public: true,
                image
            } )
        } );

        const data = await res.json();

        if ( !res.ok ) {
            throw new Error( data.message );
        }

        return data;
    };

    return {
        saveImage
    };
}

export default ImageService;
